import moment from 'moment-timezone';

import { dedupe, dedupeBy } from '@hisports/parsers';


import { getEventId, getEventResource } from '../../DragAndDropGrid';
import { getDateRange } from '../../../fields/DateRangeField';

const filterDates = (dates, weekdays = []) => {
  if (!dates?.length) return [];
  if (!weekdays?.length) return dates.sort((a, b) => a.localeCompare(b));

  return dates
    .filter(date => weekdays.includes(moment(date).locale('en').format('ddd')))
    .sort((a, b) => a.localeCompare(b));
}

const getAllScheduleDates = (schedule, filterStartDate) => {
  if (!schedule?.startDate || !schedule?.endDate) return [];
  const start = moment(filterStartDate || schedule?.startDate);
  const end = moment(schedule?.endDate);
  const allDates = [];
  do {
    allDates.push(start.format('YYYY-MM-DD'))
    start.add(1, 'day');
  } while (start.isSameOrBefore(end));
  return allDates;
}

const getDatesBeforeEnd = (dates, endDate) => {
  const endDateIndex = dates.findIndex(date => moment(date).isAfter(endDate, 'day'));
  return endDateIndex >= 0 ? dates.slice(0, endDateIndex) : dates;
}

export const buildSeasonCalendarColumns = ({
  dateFilter,
  locale,
  timezone,
  availability,
  schedule,
  scheduleTeams,
  showCondensedView,
  selectedGame,
  colOffset,
  maxColumns,
  getAlert,
  setColOffset,
}) => {
  const header = getDateRange(dateFilter?.startDate, dateFilter?.endDate, locale, timezone);
  const slots = availability?.slots || [];
  const games = availability?.games || [];
  const practices = availability?.practices || [];
  const activities = availability?.activities || [];
  const availabilities = availability?.availabilities || [];

  const eventDates = dedupe([...slots, ...games, ...practices, ...activities, ...availabilities].map(event => event.date));
  const dates = filterDates(eventDates, dateFilter?.weekdays);

  const scheduleDates = getAllScheduleDates(schedule, dateFilter?.startDate);
  const allDates = filterDates(scheduleDates, dateFilter?.weekdays);

  const selectedDates = showCondensedView ? dates : allDates;

  const teams = dedupeBy('id', (scheduleTeams || []).map(scheduleTeam => scheduleTeam.team));
  let orderedTeams = teams;

  if (selectedGame) {
    const selectedGameTeams = [selectedGame?.homeTeamId, selectedGame?.awayTeamId];
    orderedTeams = teams.filter(team => selectedGameTeams.includes(team?.id))
      .concat(teams.filter(team => !selectedGameTeams.includes(team?.id)));
  }

  return {
    header,
    disabled: false,
    alert: getAlert(teams),
    columns: orderedTeams.slice(colOffset, colOffset + maxColumns),
    totalColumns: teams.length,
    rows: getDatesBeforeEnd(dates, dateFilter?.endDate),
    allrows: getDatesBeforeEnd(allDates, dateFilter?.endDate),
    filterEvents: () => [], // placeholder if needed later
    toEventDetails: (item, eventResource, eventId, gridDateIndex) => {
      const resource = eventResource || getEventResource(item);
      const id = eventId || getEventId(item);
      const date = selectedDates?.[gridDateIndex];

      return {
        id,
        resource,
        date,
        startTime: null,
        endTime: null,
      };
    },
    onNext: () => setColOffset(colOffset + 1),
    onBack: () => setColOffset(colOffset - 1),
  };
};
